module.exports = __webpack_public_path__ + "img/aiop-logo.e86dc006.png";